/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelArControlIntercompany.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/ar-control-intercompany";

export class AutogenModelArControlIntercompany<RowType extends ModelRow> extends Endpoint<RowType, RowArControlIntercompanyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowArControlIntercompany extends ModelRow<RowArControlIntercompanyFields> {
	constructor(values?: Partial<RowArControlIntercompanyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowArControlIntercompanyFields {
	company_id: string;
	company_id_due_from: string;
	company_id_due_to: string;
	ic_asset_acct: string;
	ic_liability_acct: string;
	id: string;
}

